'use strict';
angular.module('ringbaPortal')
  .directive('trStats', function() {
    return {
      restrict: 'E',
      scope: {
        type: '@',
        subId: '=',
        showCollapseButton: '<',
        panelName: '@'
      },
      controller: 'StatsController',
      controllerAs: 'vm',
      bindToController: true,
      templateUrl: '/scripts/components/stats/stats.view.html'
    };
  });
